import { ButtonHook } from 'common/Prose/Toolbar/Types'
import { computed } from 'mobx'
import { useRootStore } from 'stores/RootStore'
import { useAuth } from 'hooks/UseAuth'

export function useTrackChangesToggle(): ButtonHook {
  const rootStore = useRootStore()
  const docStore = rootStore.docStore
  const auth = useAuth()

  if (!docStore) return { active: false, handleClick: () => {}, disabled: true }
  const { trackingChanges, setTrackingChanges } = docStore.trackedChangesStore
  const disabled = computed(
    () => !docStore.isMainLayer || (docStore.isVersionControlled && docStore.owner?.id !== auth?.id),
  ).get()
  const onClick = () => {
    !disabled && setTrackingChanges(!trackingChanges)
  }

  return { active: trackingChanges, handleClick: onClick, disabled }
}
